import BaseComponent from "@js/components/base_component.jsx";

import MuiSubAccountsIndexTable from "@js/components/mui/sub_accounts/index_table.jsx";

class MuiSubAccountsIndex extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      q: this.props.q,
    };
  }

  render() {
    const table = this.props.sub_accounts;

    return (
      <div>
        { this._renderSearchBar() }
        <br />

        <Panel heading="accounts">
          <MuiSubAccountsIndexTable
            sub_accounts={ table && table.data }
            offer_edit={ this.props.is_master_user }
            is_master_user={ this.props.is_master_user }
          />
          {table && table.total > 0 && <Paginator entity={table} />}
        </Panel>
      </div>
    );
  }

  _renderSearchBar() {
    return (
      <div className="row">
        <div className="col-sm-offset-0 col-sm-8">
          {this.props.q &&
            I18n.t("phrases.showing_search_results_for_q", { q: this.props.q })}
        </div>
        <div className="col-sm-4">
          <form onSubmit={this._onSubmitSearch}>
            <div className="input-group">
              <span className="input-with-clear-icon">
                <input
                  type="text"
                  className="form-control"
                  placeholder={I18n.t("phrases.search_sub_accounts")}
                  onChange={e => this.setState({ q: e.target.value })}
                  defaultValue={this.props.q}
                />
                {
                  this.state.q &&
                    <span onClick={ this._onClearSearch }>&times;</span>
                }
              </span>
              <span className="input-group-btn">
                <button type="submit" className="btn btn-primary">
                  <i className="fa fa-search" />
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    );
  }

  _onClearSearch(e) {
    e.preventDefault();

    Turbolinks.visit(Routes.mui_sub_accounts_path());
  }

  _onSubmitSearch(e) {
    e.preventDefault();

    Turbolinks.visit(Routes.mui_sub_accounts_path({ q: this.state.q }));
  }

}

export default MuiSubAccountsIndex;
